import { Header, Space, Spacer } from '@procurify/ui'

import { TextLoader } from '@webapp/core/components/ContentLoader'
import { AuditLogRecordStyled } from './styles/AuditLogRecordStyled'

export const AuditLogRecordLoader = () => {
  return (
    <AuditLogRecordStyled status='Cancelled'>
      <Space size='xsmall'>
        <Header as='h5'>
          <TextLoader width={150} />
        </Header>

        <TextLoader width={300} />
      </Space>

      <Spacer />

      <Space size='small'>
        <TextLoader width={100} />
        <Space direction='horizontal'>
          <TextLoader width={125} />
          <TextLoader width={125} />
        </Space>
      </Space>
    </AuditLogRecordStyled>
  )
}
